module.exports = __webpack_public_path__ + "static/img/unit-1.b5204bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-1.png
// module id = 5Eq8
// module chunks = 52